import { AuditLogRightSidebarAsync } from '@jira/admin-pages__audit-logs/src/AuditLogRightSidebarAsync.tsx';
import {
	composeLayouts,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';

/**
 * Compose the global settings layout with the audit log right sidebar.
 * This is used specifically for the admin pages audit logs route.
 *
 * By moving this composition to a separate file that's not at the route entry level,
 * we defer the evaluation and avoid webpack null-loader issues during SSR route generation.
 */
export const auditLogsLayout: Layout = composeLayouts(globalSettingsLayout, {
	rightSidebars: [AuditLogRightSidebarAsync],
});

export default auditLogsLayout;
